export default __webpack_public_path__ + "static/media/a8a11217537643483dc0a63fb10b1c2e.svg";